import {Component, OnInit, Input, TemplateRef} from '@angular/core';
import {TypeUtilService} from '../../utils/type-util.service';

/**
 * 图片预览组件
 * 使用示例：<app-img-preview [style]="{ height: '50px', width: '50px' }" [hint]="hintTemplate" [imgUrl]="item?.idCardFront"></app-img-preview>
 *
 * <ng-template #hintTemplate>
 *   <app-ellipsis content="资料缺失" [style]="{ color: '#F53B3B', width: '100px', 'margin-left': 0 }"></app-ellipsis>
 * </ng-template>
 *
 * 复杂样式建议使用 外部容器包裹实现
 *
 * TODO 后续考虑把组件名改成 app-image 语义上更贴切一点
 */
@Component({
  selector: 'app-img-preview',
  templateUrl: './img-preview.component.html',
  styleUrls: ['./img-preview.component.css']
})
export class ImgPreviewComponent implements OnInit {
  constructor(
    public typeUtilService: TypeUtilService
  ) {
  }

  // 图片链接
  @Input() imgUrl: string | null | undefined;
  @Input() src: string | null | undefined; // 作为 imgUrl 的重命名，二选一即可，功能一样
  // 是否禁用预览弹窗功能，默认不禁用
  @Input() isDisablePreview: boolean = false;
  /**
   * fill = 内容拉伸填充整个内容容器
   * contain = 保持原有尺寸比例。内容被缩放。
   * cover = 保持原有尺寸比例。但部分内容可能被剪切。
   * none = 保留原有元素内容的长度和宽度
   * scale-down = 保持原有尺寸比例。内容的尺寸与 none 或 contain 中的一个相同，取决于它们两个之间谁得到的对象尺寸会更小一些。
   */
  @Input() objectFit: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down' = 'cover';
  // 支持传入模板 或字符串
  @Input() hint: string | TemplateRef<void>;
  // 传入格式：{height: '50px', width: '50px', margin: '0 auto'}, 不传样式：图片默认按容器高宽
  @Input() style: { [key: string]: string } | string | null;

  public previewVisible = false;
  public scale = 1;

  ngOnInit(): void {
  }

  handlePreview(): void {
    if (this.isDisablePreview) {
      this.previewVisible = false;
      return;
    }
    this.scale = 1;
    this.previewVisible = true;
  }

  onMousewheel(e: any): void {
    if (e.deltaY > 0) {
      // 下滚缩小
      this.scale -= 0.1;
    } else if (e.deltaY < 0) {
      // 上滚放大
      this.scale += 0.1;
    }
  }
}
